import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  useIonViewDidEnter,
  IonFooter,
} from "@ionic/react";
import { useHistory } from "react-router";

import Navbar from "../../../components/WebApp/Navbar/Navbar";
import PubSub from "../../../lib/PubSub";
import { useRef, useState } from "react";

import { Capacitor } from "@capacitor/core";
import onboardInstagram from "../../../assets/img/icons/onboard_instagram.png";

const InstagramFollowPage: React.FC<{
  nativeMode?: boolean;
  showBackButton?: boolean;
  next: () => void;
  previous: () => void;
  hasNext: boolean;
  hasPrevious: boolean;
  step: any;
}> = ({
  nativeMode = false,
  showBackButton = false,
  next,
  previous,
  hasNext,
  hasPrevious,
  step,
}) => {
  const history = useHistory();
  const pageRef = useRef();

  const [onboardInstagramClicked, setOnboardInstagramClicked] = useState(false);

  useIonViewDidEnter(() => {
    PubSub.publish("mobileScreenChange");
  }, []);

  return (
    <IonPage ref={pageRef}>
      {nativeMode ? (
        <>
          <IonHeader>
            <IonToolbar className="pln-native-toolbar">
              {hasPrevious ? (
                <IonButtons slot="start">
                  <IonBackButton></IonBackButton>
                </IonButtons>
              ) : null}
              <IonTitle>Stay Connected</IonTitle>
            </IonToolbar>
          </IonHeader>
        </>
      ) : (
        <Navbar
          showBackButton={hasPrevious}
          actionButton={<></>}
          showMenuButton={false}
          pageName={"Stay Connected"}
          onGoBack={() => {
            history.goBack();
          }}
        ></Navbar>
      )}

      <IonContent className="bg-white">
        <div className="ion-padding">
          <div
            className="text-center flex h-full items-center"
            style={{
              height: "calc(100vh - 350px)",
            }}
          >
            <div className="mx-auto">
              <div className="rounded w-full min-h-[300px] max-h-[300px] sm:max-h-[350px] mt-[1rem] mb-[1.5rem] flex justify-center">
                <img
                  src={onboardInstagram}
                  alt="PLN+"
                  className="w-auto h-full mx-auto max-h-[300px] sm:max-h-[350px] object-contain"
                />
              </div>

              <h2 className="font-medium font-[SourceSerif] text-2xl mb-[0.5rem]">
                Follow Us On Instagram
              </h2>

              <p className="" style={{ fontSize: 18 }}>
                Stay up to date with the latest news, menus, and promotions by
                following us on Instagram!
              </p>
            </div>
          </div>
        </div>
      </IonContent>
      <IonFooter>
        <IonToolbar
          className={`pln-native-toolbar-footer ${
            !Capacitor.isNativePlatform() ? "web" : ""
          }`}
        >
          {onboardInstagramClicked ? (
            <IonButton
              onClick={async () => {
                next();
              }}
              expand="block"
              mode={
                Capacitor.isNativePlatform()
                  ? Capacitor.getPlatform() === "ios"
                    ? "ios"
                    : "md"
                  : "ios"
              }
            >
              Continue
            </IonButton>
          ) : (
            <IonButton
              onClick={() => {
                // Prompt for notifications

                setOnboardInstagramClicked(true);

                if (Capacitor.isNativePlatform()) {
                  if (Capacitor.getPlatform() == "ios") {
                    window.open(
                      "instagram://user?username=projectleannation",
                      "_blank",
                    );
                  } else {
                    window.open(
                      "instagram://user?username=projectleannation",
                      "_blank",
                    );
                  }
                } else {
                  window.open(
                    "https://instagram.com/projectleannation",
                    "_blank",
                  );
                }
              }}
              expand="block"
              mode={
                Capacitor.isNativePlatform()
                  ? Capacitor.getPlatform() == "ios"
                    ? "ios"
                    : "md"
                  : "ios"
              }
            >
              Follow Us On Instagram
            </IonButton>
          )}
          {!onboardInstagramClicked ? (
            <IonButton
              onClick={async () => {
                next();
              }}
              expand="block"
              color="dark"
              fill="clear"
              mode={
                Capacitor.isNativePlatform()
                  ? Capacitor.getPlatform() === "ios"
                    ? "ios"
                    : "md"
                  : "ios"
              }
            >
              {onboardInstagramClicked ? "Continue" : "Maybe Later"}
            </IonButton>
          ) : (
            <></>
          )}
        </IonToolbar>
      </IonFooter>
    </IonPage>
  );
};

export default InstagramFollowPage;
